export default "__VITE_ASSET__BPFbaKfV__"